/**
 * The threshold to show the back to top button.
 */
export const BACK_TO_TOP_THRESHOLD: number = 300 as const;

export const BACK_TO_TOP_HIDE_DELAY: number = 2000 as const;
